// extracted by css-extract-rspack-plugin
export default {"Icon":"AbjaxFUtxpIG3KH5","spin":"bqITVJIZsUD9K3OP","RotateAnimation":"KHTk2sDSDqkgS1F3"};